import React from "react";

import Icon from "../Icon";
import * as styles from "./style.module.scss";

const CalculatorMessage = ({ icon = "bullhorn", children }) => {
    return (
        <div className={`box`}>
            <div className={"columns is-mobile"}>
                <div className={`column is-2 ${styles.icon}`}>
                    <Icon type={icon} />
                </div>
                <div className={"column"}>{children}</div>
            </div>
        </div>
    );
};

export default CalculatorMessage;
